var BaseZone = require('./frApiBaseZone');


module.exports = BaseZone.extend({


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/models/api/zone/frApiHighlightZone.js
 ** module id = 678
 ** module chunks = 0
 **/